// extracted by mini-css-extract-plugin
export default {"container":"OrderDetails_container__iJZOV","titleNumbers":"OrderDetails_titleNumbers__gfstG","image":"OrderDetails_image__ARNAX"};